import { render, staticRenderFns } from "./schedule-data-table-name.component.vue?vue&type=template&id=31898d0a&scoped=true&"
import script from "./schedule-data-table-name.component.vue?vue&type=script&lang=ts&"
export * from "./schedule-data-table-name.component.vue?vue&type=script&lang=ts&"
import style0 from "./schedule-data-table-name.component.vue?vue&type=style&index=0&id=31898d0a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31898d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VMenu})
